<div>
  <div class="d-block">
    <img class="logo_profile" src="../../assets/images/green_logo_1.svg" />
  </div>
  <div class="d-flex">
    <div class="col-md-5 d-inline-block bg_back d-none d-md-block">
      <img class="bg_back" src="../../assets/images/girl_img1.svg" />
    </div>
    <div class="d-inline-block col-md-5 col-sm-12" style="overflow: auto">
      <p class="hello_">Hello {{ userData.userName }}</p>
      <p>
        Help us setup your Schoold™ profile by completing the following form.
      </p>

      <mat-horizontal-stepper labelPosition="bottom" #stepper>
        <mat-step [editable]="isEditable" disableRipple="true">
          <ng-template matStepLabel>Personal Details</ng-template>
          <form [formGroup]="personalDetailForm">
            <div [style.height]="'calc(100vh - 297px)'" class="position-relative">
              <div class="row">
                <div class="col-6">
                  <input class="w-100 input_ mt-3" formControlName="name" disabled placeholder="Name" type="text" />
                </div>

                <div class="col-6">
                  <input class="w-100 input_ mt-3" formControlName="address" placeholder="Address" type="text" />
                  <div *ngIf="
                      personalDetailForm.controls['address'].invalid &&
                      (personalDetailForm.controls['address'].dirty ||
                        personalDetailForm.controls['address'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="
                        personalDetailForm.controls['address'].errors.required
                      ">
                      *Address is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <input class="w-100 input_ mt-3" formControlName="city" placeholder="City" type="text" />
                  <div *ngIf="
                      personalDetailForm.controls['city'].invalid &&
                      (personalDetailForm.controls['city'].dirty ||
                        personalDetailForm.controls['city'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="
                        personalDetailForm.controls['city'].errors.required
                      ">
                      *City is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <input class="w-100 input_ mt-3" formControlName="state" placeholder="State" type="text" />
                  <div *ngIf="
                      personalDetailForm.controls['state'].invalid &&
                      (personalDetailForm.controls['state'].dirty ||
                        personalDetailForm.controls['state'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="
                        personalDetailForm.controls['state'].errors.required
                      ">
                      *State is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <select [style.cursor]="'pointer'" formControlName="countryId" name="cars" id="cars" class="mt-3">
                    <option value="">Select Country</option>
                    <option [value]="data._id" *ngFor="let data of countryList">
                      {{ data.country }}
                    </option>
                  </select>

                  <div *ngIf="
                      personalDetailForm.controls['countryId'].invalid &&
                      (personalDetailForm.controls['countryId'].dirty ||
                        personalDetailForm.controls['countryId'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="
                        personalDetailForm.controls['countryId'].errors.required
                      ">
                      *Country is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <select [style.cursor]="'pointer'" name="cars" formControlName="citizenshipId" id="cars" class="mt-3">
                    <option value="">CitizenShip Status</option>
                    <option [value]="data._id" *ngFor="let data of citizenshipList">
                      {{ data.citizenshipName }}
                    </option>
                  </select>
                  <div *ngIf="
                      personalDetailForm.controls['citizenshipId'].invalid &&
                      (personalDetailForm.controls['citizenshipId'].dirty ||
                        personalDetailForm.controls['citizenshipId'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="
                        personalDetailForm.controls['citizenshipId'].errors
                          .required
                      ">
                      *Citizenship Status is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <select [style.cursor]="'pointer'" name="cars" formControlName="gender" id="cars" class="mt-3">
                    <option value="">Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Gender Variant/Nonconformity">
                      Gender Variant/Nonconformity
                    </option>
                    <option value="Not Listed">Not Listed</option>
                    <option value="Prefer Not to Answer">
                      Prefer Not to Answer
                    </option>
                  </select>
                  <div *ngIf="
                      personalDetailForm.controls['gender'].invalid &&
                      (personalDetailForm.controls['gender'].dirty ||
                        personalDetailForm.controls['gender'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="
                        personalDetailForm.controls['gender'].errors.required
                      ">
                      *Gender is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div *ngIf="isChange == false">
                    <select [style.cursor]="'pointer'" formControlName="ethnicityId" name="cars" id="cars" class="mt-3"
                      (change)="getSelectedEthnicity($event)">
                      <option value="">Ethnicity</option>
                      <option [value]="data._id" *ngFor="let data of ethnicityList">
                        {{ data.ethnicityName }}
                      </option>
                    </select>
                    <div *ngIf="
                        personalDetailForm.controls['ethnicityId'].invalid &&
                        (personalDetailForm.controls['ethnicityId'].dirty ||
                          personalDetailForm.controls['ethnicityId'].touched)
                      " class="errorinput text-left">
                      <div *ngIf="
                          personalDetailForm.controls['ethnicityId'].errors
                            .required
                        ">
                        *Ethnicity is required.
                      </div>
                    </div>
                  </div>

                  <div *ngIf="isChange == true" class="col-sm-12 p-0">
                    <div class="form-group position-relative">
                      <input id="input" type="text" formControlName="ethnicity" class="w-100 input_ mt-3"
                        placeholder="Enter Text" />
                      <span class="cancelImg position-absolute"><img (click)="cancelInput()"
                          src="../../assets/images/close.png" style="height: 11px; width: 11px" /></span>
                      <div *ngIf="
                          personalDetailForm.controls['ethnicity'].invalid &&
                          (personalDetailForm.controls['ethnicity'].dirty ||
                            personalDetailForm.controls['ethnicity'].touched)
                        " class="errorinput text-left">
                        <div *ngIf="
                            personalDetailForm.controls['ethnicity'].errors
                              .required
                          ">
                          *Other is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end position-absolute btn_div">
                <button class="orange_btn bordered_btn btn" (click)="getFormData()">
                  Next
                </button>
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step [editable]="isEditable">
          <ng-template matStepLabel>Academic Details</ng-template>

          <form [formGroup]="academicForm">
            <div [style.height]="'calc(100vh - 297px)'" class="position-relative">
              <div class="row">
                <div class="col-6">
                  <select [style.cursor]="'pointer'" formControlName="levelOfEduId" name="cars" id="cars" class="mt-3">
                    <option value="">Level of Education</option>
                    <option [value]="data._id" *ngFor="let data of educationList">
                      {{ data.title }}
                    </option>
                  </select>
                  <div *ngIf="
                      academicForm.controls['levelOfEduId'].invalid &&
                      (academicForm.controls['levelOfEduId'].dirty ||
                        academicForm.controls['levelOfEduId'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="
                        academicForm.controls['levelOfEduId'].errors.required
                      ">
                      *Level of Education is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <select [style.cursor]="'pointer'" formControlName="schoolId" name="cars" id="cars" class="mt-3">
                    <option value="">School Names</option>
                    <option [value]="data._id" *ngFor="let data of schoolNameList">
                      {{ data.title }}
                    </option>
                  </select>
                  <div *ngIf="
                      academicForm.controls['schoolId'].invalid &&
                      (academicForm.controls['schoolId'].dirty ||
                        academicForm.controls['schoolId'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="academicForm.controls['schoolId'].errors.required">
                      *School Name is required.
                    </div>
                  </div>
                </div>

                <div class="col-6 mt-3">
                  <button class="btn input_ w-100" #Btn (click)="OpenActivityModal(delete, Btn)">
                    Add Extra Curricular Activities
                  </button>
                  <p class="m-0 count_" [style.cursor]="'pointer'"
                    [ngClass]="{'no_click':allSelectedActivities.length == 0}"
                    (click)="OpenModal(addedactivities, Btn)">Added activities: {{allSelectedActivities?.length}}</p>

                </div>

                <div class="col-6">
                  <span class="me-2">GPA</span>
                  <input class="w-25 input_ mt-3" formControlName="gpa" placeholder="0.0" type="text"
                    (keypress)="onlyNumberKey($event)" />
                  <div *ngIf="
                      academicForm.controls['gpa'].invalid &&
                      (academicForm.controls['gpa'].dirty ||
                        academicForm.controls['gpa'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="academicForm.controls['gpa'].errors.required">
                      *Gpa is required.
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end btn_div position-absolute">
                <button (click)="back()" class="bordered_btn grey_btn btn me-3">
                  Back
                </button>
                <button (click)="nextToFinancialScreen()" class="bordered_btn orange_btn btn">
                  Next
                </button>
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step [editable]="isEditable">
          <ng-template matStepLabel>Financial Details</ng-template>
          <form [formGroup]="financialForm">
            <div [style.height]="'calc(100vh - 297px)'" class="position-relative">
              <div class="row">
                <div class="col-6">
                  <select [style.cursor]="'pointer'" formControlName="incomeId" name="cars" id="cars" class="mt-3">
                    <option value="">Household Income</option>
                    <option [value]="data._id" *ngFor="let data of houseHoldList">
                      {{ data.value }}
                    </option>
                  </select>
                  <div *ngIf="
                      financialForm.controls['incomeId'].invalid &&
                      (financialForm.controls['incomeId'].dirty ||
                        financialForm.controls['incomeId'].touched)
                    " class="errorinput text-left">
                    <div *ngIf="financialForm.controls['incomeId'].errors.required">
                      *House Hold Income is required.
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <input class="w-100 input_ mt-3" formControlName="efc" placeholder="EFC(optional)" type="text" />
                </div>
              </div>
              <div class="text-end position-absolute btn_div">
                <button matStepperPrevious class="bordered_btn grey_btn btn me-3">
                  Back
                </button>
                <button class="bordered_btn orange_btn btn" (click)="save()">
                  Save
                </button>
              </div>
            </div>
          </form>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</div>
<app-spinner *ngIf="isLoading == true"></app-spinner>

<ng-template #delete let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
  <div class="modal-header">
    <h5 class="modal-title">List of all Extra Curricular Activities</h5>
    <button type="button" class="close btn cross_btn" data-dismiss="modal" (click)="closeModal('dismiss')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="row align-items-end ms-3 mt-3" *ngIf="activityList.length">
    <div class="col-8">
      <label [style.font-size]="'12px'">Choose Extra Curricular Activity</label>
      <ng-multiselect-dropdown class="w-50" [placeholder]="'Extracurricular Activities'"
        [settings]="dropdownSettingCircle" [data]="activityList" [(ngModel)]="selectedActivity"
        (onSelect)="onItemSelectRole($event)" (onSelectAll)="onSelectAllRole($event)"
        (onDeSelect)="onItemDeSelectRole($event)">
      </ng-multiselect-dropdown>

    </div>
    <div class="col">
      <button class="btn clear_" (click)="clearExtraCurricular()">Clear</button>
    </div>
  </div>
  <!-- table -->
  <div class="col-md-12 mt-5 pe-5 ps-5">
    <div class="table-responsive" *ngIf="selectedActivities.length > 0">
      <table class="table table-class">
        <thead class="tableheading">
          <tr>
            <th>Activity</th>
            <th scope="col" style="white-space: nowrap">Organization</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of selectedActivities; index as i">
            <td class="_noWrap" style="width: 50%;color:black">{{ data?.title }}</td>
            <td>
              <input type="text" placeholder="Enter Content Of Organization Name" [(ngModel)]="data.text"
                class="w-100 input_" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button class="bordered_btn orange_btn btn" (click)="saveActivityLocal()">Save</button>
  </div>
</ng-template>


<ng-template #addedactivities let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
  <div class="modal-header">
    <h5 class="modal-title">List of Selected Activities</h5>
    <button type="button" class="close btn cross_btn" data-dismiss="modal" (click)="closeModal('dismiss')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 mt-2 pe-5 ps-5">
      <div class="table-responsive" *ngIf="allSelectedActivities.length > 0">
        <table class="table table-class">
          <thead class="tableheading">
            <tr>
              <th>Activity</th>
              <th scope="col" style="white-space: nowrap">Organization</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of allSelectedActivities; index as i">
              <td class="_noWrap" style="width: 50%;color:black">{{ data?.title }}</td>
              <td>
                <p>{{data.text ? data.text : "--"}}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>